// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

const nameToPath = name => name.replace(/]/g, '').split('[');

const fixObj = (obj, key) => {
    if (isNaN(key) && (Array.isArray(obj) || typeof obj !== 'object' || obj === null)) {
        return {};
    }
    if (!isNaN(key) && !Array.isArray(obj)) {
        return [];
    }
    return obj;
};

const get = (obj, name, def) => {
    const path = nameToPath(name);
    let val;
    try {
        val = path.reduce((curr, key) => curr[key], obj);
    } catch (e) {}
    return val === undefined ? def : val;
};

const set = (obj, name, val) => {
    const path = nameToPath(name);

    obj = fixObj(obj, path[0]);

    let key;
    let curr = obj;

    while ((key = path.shift()) && path.length) {
        curr[key] = fixObj(curr[key], path[0]);
        curr = curr[key];
    }
    curr[key] = val;

    return obj;
};

export {
    get,
    set,
};



// WEBPACK FOOTER //
// ./components/Form/utils.js